export enum FileMenuActionEnum {
  Open = 'open',
  OpenShortcutOriginalFileLocation = 'openShortcutOriginalFileLocation',
  Download = 'download',
  DownloadEncrypted = 'downloadEncrypted',
  Share = 'share',
  Rename = 'rename',
  Organize = 'organize',
  Tags = 'tags',
  AddToFavorites = 'addToFavorites',
  RemoveFromFavorites = 'removeFromFavorites',
  Hide = 'hide',
  Unhide = 'unhide',
  Delete = 'delete',
  DeletePermanently = 'deletePermanently',
  Replace = 'replace',
  Duplicate = 'duplicate',
  Move = 'move',
  CreateShortcut = 'createShortcut',
  Divider = 'divider',
  RestoreFromTrash = 'restoreFromTrash',
  SaveTags = 'saveTags',
  SellFile = 'sellFile',
  Details = 'details',
  EmptyTrash = 'emptyTrash',
  Classify = 'classify',
  ArtificalIntelligence = 'artificalIntelligence',
  ArtificalIntelligenceSummary = 'artificalIntelligenceSummary',
  ArtificalIntelligenceDocumentChat = 'artificalIntelligenceDocumentChat',
  CopyLink = 'copyLink',
}
